export default class IncidentId {
  static fromPushMessageFormat(incidentId: string): number {
    return Number(incidentId.split('-')[1])
  }
}
